// Triggers the browser's print engine to export the print-only .brochure
// layout as a high-quality, vector PDF (selectable text, crisp at any zoom).
// The website itself is hidden in print via @media print rules in index.css.
export function exportBrochurePdf() {
  const prevTitle = document.title;
  // Browsers use document.title as the default "Save as PDF" filename.
  document.title = "MPS-MWP1110-Brochure";

  const restore = () => {
    document.title = prevTitle;
    window.removeEventListener("afterprint", restore);
  };
  window.addEventListener("afterprint", restore);

  // Defer one frame so the title change is applied before the dialog opens.
  requestAnimationFrame(() => {
    window.print();
    // Safety net for browsers that don't fire afterprint.
    setTimeout(restore, 1500);
  });
}
